import * as React from "react";

/**
 * A component that exists only in a development build.
 *
 * The loader is a dynamic import, so the module it names never enters the
 * production bundle: with `import.meta.env.DEV` false Vite drops the whole
 * branch, and the returned component renders nothing. In development the
 * module loads lazily behind a `Suspense` with no fallback, so a debug tool
 * never shifts the layout it inspects.
 */
export function devOnly(
  load: () => Promise<{ default: React.ComponentType }>,
): React.ComponentType {
  if (!import.meta.env.DEV) {
    return function ProductionNoop() {
      return null;
    };
  }
  const Lazy = React.lazy(load);
  return function DevOnly() {
    return (
      <React.Suspense fallback={null}>
        <Lazy />
      </React.Suspense>
    );
  };
}
